import React, { Fragment } from 'react'
import { Link, NavLink } from 'react-router-dom'
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import ReplyIcon from '@mui/icons-material/Reply';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import InfoIcon from '@mui/icons-material/Info';
import LockIcon from '@mui/icons-material/Lock';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import RedeemIcon from '@mui/icons-material/Redeem';

import './myAccountPrivilage.css'

const supportLinks = [
    { to: '/how-to-shop', label: 'How to shop', icon: <ShoppingBagIcon /> },
    { to: '/promotions', label: 'Promotions', icon: <VolumeUpIcon /> },
    { to: '/about/return-and-exchange', label: 'Returns & exchanges', icon: <ReplyIcon /> },
    { to: '/about/Shipping-Tracking', label: 'Shipping & tracking', icon: <LocalShippingIcon /> },
    { to: '/about/Product-And-Pricing', label: 'Products & pricing', icon: <InfoIcon /> },
    { to: '/about/Security', label: 'Security', icon: <LockIcon /> },
    { to: '/about/Payment', label: 'Payment', icon: <AttachMoneyIcon /> },
    { to: '/about/GiftBox', label: 'Gift box', icon: <RedeemIcon /> },
];

function SideBarAccount() {
    return (
        <Fragment>

            <div className="left-side-buttons-for-buy">
                <span className="support-sidebar-kicker">Help center</span>
                <h3>Shopping support</h3>
                {supportLinks.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        className="buttons-for-shop"
                        activeClassName="active-support-link"
                        exact={item.to === '/how-to-shop' || item.to === '/promotions'}
                    >
                        {item.icon}
                        <span>{item.label}</span>
                    </NavLink>
                ))}

            </div>

            <div className="left-side-container">

                <span>Need help?</span>
                <p>Tell us what happened and our support team will help with orders, returns, payment, or delivery questions.</p>
                <div className="button-for-submit">
                    <Link to='/user/complain/request'><button>SUBMIT A REQUEST</button></Link>
                </div>

            </div>

        </Fragment>
    )
}

export default SideBarAccount
